<template>
  <Modal variant="task" class="is-proposal" @close="close">
    <template slot="content">
      <div class="p-tasklist-form p-tasklist-form--proposal">
        <div class="p-tasklist-form--proposal__header">
          <div class="c-image--radius l-mr-2">
            <img src="@/assets/img/img-chara-task.svg" alt="" width="50" />
          </div>
          <div class="p-tasklist-form--proposal__head">
            <h2 class="p-tasklist-form--proposal__title">
              SEARCH WRITEから改善提案タスク
              <Button
                radius
                variant="trash"
                :disabled="isDeleting || isProcessing"
                @click="deleteTask"
              >
                <Tooltip variant="btn">
                  タスクを削除
                </Tooltip>
              </Button>
            </h2>
            <div class="c-list--category">
              <p v-if="category" :class="categoryCssClass">
                {{ category }}
              </p>
              <div class="c-text--note" v-if="taskUpdatedDate">
                タスク編集日: {{ taskUpdatedDate }}
              </div>
            </div>
          </div>
        </div>
        <div
          class="p-tasklist-form__content p-tasklist-form--proposal__content"
        >
          <div class="p-tasklist-form-proposal">
            <p class="p-tasklist-form-proposal__title">
              {{ text.title }}
            </p>
            <p v-if="text.body" class="c-text--prewrap">{{ text.body }}</p>
            <dl v-if="item.keyword" class="p-tasklist-form-proposal__target">
              <dt class="c-text--note">対象となるキーワード</dt>
              <dd class="c-text--main">{{ item.keyword }}</dd>
            </dl>
            <dl
              v-if="item.url && item.type != 'createContent'"
              class="p-tasklist-form-proposal__target"
            >
              <dt class="c-text--note">対象となるURL</dt>
              <dd>
                <a :href="item.url" target="_blank" class="c-link--blank">
                  {{ item.url }}
                </a>
              </dd>
            </dl>
          </div>
          <div
            v-if="item.type == 'createContent'"
            class="c-fieldset c-fieldset--wrap"
          >
            <div class="c-fieldset__header">
              <p class="c-fieldset__title">
                施策を実施するページURLを登録する
              </p>
            </div>
            <div class="c-fieldset__content c-alertPos">
              <InputUrl :url="project.siteUrl">
                <Input
                  v-model="params.url"
                  placeholder="/"
                  size="sm"
                  @focusout="focusoutUrl"
                />
              </InputUrl>
            </div>
          </div>
          <div class="c-fieldset c-fieldset--wrap">
            <div class="c-fieldset__header">
              <p class="c-fieldset__title">タスクに担当者を設定する</p>
            </div>
            <div class="c-fieldset__content c-alertPos">
              <Select
                v-model="params.operator"
                :options="projectUsers"
                placeholder="担当者なし"
                :selected="params.operator"
                :class="{
                  alert: error.operator
                }"
              />
              <Alert v-if="error.operator">
                {{ error.operator }}
              </Alert>
            </div>
          </div>
          <div class="c-fieldset c-fieldset--wrap">
            <div class="c-fieldset__header">
              <p class="c-fieldset__title">メモ</p>
            </div>
            <div class="c-fieldset__content">
              <Textarea
                v-model="params.note"
                v-focus
                placeholder="施策内容についてのメモを残すことができます"
              />
            </div>
          </div>
          <div class="c-fieldset c-fieldset--wrap">
            <div class="c-fieldset__header">
              <p class="c-fieldset__title">施策完了予定日</p>
            </div>
            <div class="c-fieldset__content c-alertPos">
              <DatePicker v-model="params.executionDate" :max-date="null" />
              <Alert v-if="error.executionDate">
                {{ error.executionDate }}
              </Alert>
            </div>
          </div>
          <div class="c-fieldset c-fieldset--wrap">
            <div class="c-fieldset__header">
              <p class="c-fieldset__title">施策完了日</p>
            </div>
            <div class="c-fieldset__content c-alertPos">
              <DatePicker v-model="params.typeDoneDate" />
              <Alert v-if="error.typeDoneDate">
                {{ error.typeDoneDate }}
              </Alert>
            </div>
          </div>
          <div class="p-tasklist-form__footer">
            <Button class="p-tasklist-form__cancel" @click="close">
              <Icon2 variant="close" :size="10" />
              キャンセル
            </Button>
            <div class="c-alertPos">
              <Button
                variant="main"
                size="w230"
                fsize="f16"
                icon="plus"
                :class="{ 'is-loading': isProcessing }"
                :disabled="isDisabled"
                @click="editTask"
              >
                タスクを更新する
              </Button>
              <Alert v-if="errorResponse">
                {{ errorResponse }}
              </Alert>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { ERROR_MESSAGE } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Icon2 from '@/components/Icon2';
import Input from '@/components/Input';
import InputUrl from '@/components/InputUrl';
import Modal from '@/components/Modal';
import Select from '@/components/Select';
import Textarea from '@/components/Textarea';
import Tooltip from '@/components/Tooltip';
import apiProjects from '@/api/projects';
import DatePicker from '@/components/DatePicker';
import utils from '@/utils';

export default {
  props: {
    item: {
      type: Object,
      required: false
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Icon2,
    Input,
    InputUrl,
    Modal,
    Select,
    Textarea,
    Tooltip,
    DatePicker
  },
  data() {
    return {
      error: {
        operator: '',
        typeDoneDate: ''
      },
      errorResponse: '',
      params: {
        url: this.$options.filters.removeDomain(
          this.item.url,
          this.project.siteUrl
        ),
        note: this.item.note || '',
        operator: this.item.operatorUserId || '',
        executionDate: this.item.executionDate
          ? new Date(this.item.executionDate)
          : null,
        typeDoneDate: this.item.typeDoneDate
          ? new Date(this.item.typeDoneDate)
          : null
      },
      isDeleting: false,
      isEdited: {
        url: false,
        note: false,
        operator: false,
        executionDate: false,
        typeDoneDate: false
      },
      isProcessing: false
    };
  },
  computed: {
    category() {
      let category = '';
      if (this.categoryLabel[this.item.type]) {
        category = '提案 - ' + this.categoryLabel[this.item.type];
      }
      return category;
    },
    categoryCssClass() {
      return {
        'c-list--category__item': true,
        ['c-list--category__item--' + this.item.type]: this.item.type
      };
    },
    categoryLabel() {
      return this.$store.getters['task/solutionLabel'];
    },
    projectUsers() {
      return this.$store.getters['project/usersSelect'];
    },
    projectUsersName() {
      return this.$store.getters['project/usersName'];
    },
    taskUpdatedDate() {
      return this.item.updatedAt
        ? utils.formatDate(this.item.updatedAt, 'YYYY.MM.DD')
        : null;
    },
    text() {
      let array = this.item.taskDetail.split('\n');
      let title = array.shift();
      let body = array.join('\n');
      return {
        title: title,
        body: body
      };
    },
    isDisabled() {
      return (
        this.isError ||
        this.isProcessing ||
        !(
          this.isEdited.url ||
          this.isEdited.note ||
          this.isEdited.operator ||
          this.isEdited.executionDate ||
          this.isEdited.typeDoneDate
        )
      );
    },
    isError() {
      return this.error.operator ? true : false;
    }
  },
  watch: {
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.errorResponse = '';
      },
      deep: true
    },
    'params.note': {
      handler(value, oldValue) {
        const note = value.trim();
        if (this.item.note) {
          this.isEdited.note = note !== this.item.note;
        } else if (typeof oldValue !== 'undefined') {
          this.isEdited.note = note ? true : false;
        }
      },
      immediate: true
    },
    'params.operator': {
      handler(value, oldValue) {
        const operator = value;
        this.error.operator = '';
        if (this.item.operatorUserId) {
          this.isEdited.operator = operator !== this.item.operatorUserId;
        } else if (typeof oldValue !== 'undefined') {
          this.isEdited.operator = operator ? true : false;
        }
      },
      immediate: true
    },
    'params.executionDate': {
      handler(value, oldValue) {
        this.isEdited.executionDate =
          utils.formatDate(value, 'YYYY-MM-DD') !==
          utils.formatDate(this.item.executionDate, 'YYYY-MM-DD');
      },
      immediate: true
    },
    'params.typeDoneDate': {
      handler(value, oldValue) {
        this.isEdited.typeDoneDate =
          utils.formatDate(value, 'YYYY-MM-DD') !==
          utils.formatDate(this.item.typeDoneDate, 'YYYY-MM-DD');
      },
      immediate: true
    },
    'params.url': {
      handler(value, oldValue) {
        const url = value.trim();

        const oldUrl = this.$options.filters.removeDomain(
          this.item.url,
          this.project.siteUrl
        );
        this.isEdited.url = url !== oldUrl;
      },
      immediate: true
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    deleteTask() {
      if (this.isDeleting || this.isProcessing) {
        return;
      }
      this.isDeleting = true;

      apiProjects.tasks
        .delete(this.auth.idToken, this.project.id, this.item.id)
        .then(response => {
          this.$emit('delete', this.item);
          this.isDeleting = false;
        })
        .catch(error => {
          this.isDeleting = false;
        });
    },
    async editTask() {
      if (this.isDisabled) {
        return;
      }
      this.isProcessing = true;
      this.errorResponse = '';

      // ユーザーの存在チェック
      if (this.params.operator) {
        await this.getUsers();
        if (this.error.operator) {
          this.isProcessing = false;
          return;
        }
      }
      await this.putTask();

      this.isProcessing = false;
    },
    getUsers() {
      return this.$store.dispatch('project/getUsers').finally(() => {
        const existUser = this.projectUsers.some(
          user => user.value === this.params.operator
        );
        if (!existUser) {
          this.error.operator =
            '選択したユーザーが存在しません。担当者を再度設定してください';
        }
      });
    },
    putTask() {
      const params = {
        column: null,
        keyword: this.item.keyword,
        note: this.params.note,
        operatorUserId: this.params.operator || null,
        position: null,
        taskDetail: this.item.taskDetail,
        type: this.item.type,
        url:
          this.item.type == 'createContent'
            ? this.getFullUrl(this.params.url)
            : this.item.url,
        executionDate: this.params.executionDate
          ? utils.formatDate(this.params.executionDate, 'YYYY-MM-DD')
          : null,
        typeDoneDate: this.params.typeDoneDate
          ? utils.formatDate(this.params.typeDoneDate, 'YYYY-MM-DD')
          : null,
        updatedAt: this.item.updatedAt
      };

      return apiProjects.tasks
        .put(params, this.auth.idToken, this.project.id, this.item.id)
        .then(response => {
          const item = Object.assign({}, this.item);
          if (this.item.type == 'createContent') {
            item.url = params.url;
          }
          item.note = this.params.note;
          item.operatorUserId = this.params.operator;
          item.operatorUserName = this.projectUsersName[this.params.operator];
          item.executionDate = this.params.executionDate;
          item.typeDoneDate = this.params.typeDoneDate;
          item.updatedAt = response.data.updatedAt;
          this.$emit('edit', item);
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          } else {
            this.errorResponse = ERROR_MESSAGE.other;
          }
        });
    },
    focusoutUrl() {
      this.params.url = this.$options.filters.normalizeAllSpaces(
        this.params.url
      );
      // 先頭が/じゃないURLが入力されていたら、スラッシュを付ける
      if (this.params.url && !/^\//.test(this.params.url)) {
        this.params.url = '/' + this.params.url;
      }
    },
    getFullUrl(url) {
      if (!url) {
        return null;
      }
      return (
        this.$options.filters.removeTrailingSlash(this.project.siteUrl) +
        '/' +
        this.$options.filters.removeLeadingSlash(url)
      );
    }
  }
};
</script>
